import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "accountMenu"
}
const _hoisted_2 = { class: "menuTitle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_4 = { href: "/Account/ChangePassword" }
const _hoisted_5 = { href: "/Account/Logout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["HeaderButton"], {
      modelValue: $setup.MenuOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.MenuOpen) = $event)),
      icon: "url(../icons/account.png)"
    }, null, 8 /* PROPS */, ["modelValue"]),
    ($setup.MenuOpen)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createVNode($setup["Resource"], { res: "layout_accountmenutitle" })
          ]),
          _hoisted_3,
          _createElementVNode("a", _hoisted_4, [
            _createVNode($setup["Resource"], { res: "layout_changepassword" })
          ]),
          _createElementVNode("a", _hoisted_5, [
            _createVNode($setup["Resource"], { res: "layout_signout" })
          ])
        ])), [
          [_directive_click_outside, () => $setup.MenuOpen = false]
        ])
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}